import Icon from "@ant-design/icons";

const Component = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16797 11V7H7.16797V8H8.16797V11H6.66797V12H10.668V11H9.16797ZM8.66797 4C8.51963 4 8.37463 4.04399 8.25129 4.1264C8.12795 4.20881 8.03182 4.32594 7.97506 4.46299C7.91829 4.60003 7.90344 4.75083 7.93238 4.89632C7.96132 5.0418 8.03275 5.17544 8.13764 5.28033C8.24253 5.38522 8.37617 5.45665 8.52165 5.48559C8.66714 5.51453 8.81794 5.49968 8.95498 5.44291C9.09203 5.38614 9.20916 5.29001 9.29157 5.16668C9.37398 5.04334 9.41797 4.89834 9.41797 4.75C9.41797 4.55109 9.33895 4.36032 9.1983 4.21967C9.05765 4.07902 8.86688 4 8.66797 4Z"
      fill="currentColor"
    />
    <path
      d="M8.33203 15.3335C6.94757 15.3335 5.59419 14.923 4.44304 14.1538C3.2919 13.3846 2.39469 12.2914 1.86488 11.0123C1.33506 9.7332 1.19644 8.32573 1.46654 6.96787C1.73663 5.61 2.40332 4.36272 3.38229 3.38375C4.36125 2.40478 5.60854 1.7381 6.9664 1.468C8.32427 1.19791 9.73174 1.33653 11.0108 1.86634C12.2899 2.39616 13.3832 3.29336 14.1523 4.44451C14.9215 5.59565 15.332 6.94903 15.332 8.3335C15.332 10.19 14.5945 11.9705 13.2818 13.2832C11.969 14.596 10.1885 15.3335 8.33203 15.3335ZM8.33203 2.3335C7.14535 2.3335 5.98531 2.68539 4.99861 3.34468C4.01192 4.00397 3.24288 4.94104 2.78876 6.0374C2.33463 7.13376 2.21581 8.34015 2.44732 9.50404C2.67883 10.6679 3.25028 11.737 4.08939 12.5761C4.92851 13.4153 5.99761 13.9867 7.16149 14.2182C8.32538 14.4497 9.53178 14.3309 10.6281 13.8768C11.7245 13.4227 12.6616 12.6536 13.3209 11.6669C13.9801 10.6802 14.332 9.52019 14.332 8.3335C14.332 6.7422 13.6999 5.21608 12.5747 4.09086C11.4495 2.96564 9.92333 2.3335 8.33203 2.3335Z"
      fill="currentColor"
    />
  </svg>
);

export const InfoIcon = (props) => <Icon component={Component} {...props} />;
